import React from "react";

export default function CloseButton(props) {

    const { closeText,
        closeDashboardToggleId,
        handleDashboardCollapse } = props;

    return (
        <a href={closeDashboardToggleId} onClick={(e) => handleDashboardCollapse(e.target.getAttribute("href"))}>
            <i className="ico-close">
                <svg aria-hidden="true">
                    <use href="/static/images/Boss/svg/BossIconLibrarySprite.svg#ico-close"></use>
                </svg>
            </i>
            <span>{closeText}</span>
        </a>
    );
}